var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3h3a1 1 0 1 1 0 2H5v3a1 1 0 1 1-2 0V5c0-1.093.907-2 2-2zm11 0h3c1.093 0 2 .907 2 2v3a1 1 0 1 1-2 0V5h-3a1 1 0 1 1 0-2zM3.984 14.986A1 1 0 0 1 5 16v3h3a1 1 0 1 1 0 2H5c-1.093 0-2-.907-2-2v-3a1 1 0 0 1 .984-1.014zm16 0A1 1 0 0 1 21 16v3c0 1.093-.907 2-2 2h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 .984-1.014zM8.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm7 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-6.506 5.992a1 1 0 0 1 .656.2c.572.415 1.367.808 2.35.808.983 0 1.777-.394 2.348-.809a1 1 0 1 1 1.177 1.618C14.722 16.394 13.517 17 12 17s-2.721-.607-3.525-1.191a1 1 0 0 1 .52-1.817z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.10547b364bcd417b3f47354b124cca65.svg";
export { ForwardRef as ReactComponent };